import { Link } from 'react-router-dom';
import {
  Card,
  CardButton,
  Content,
  Heading,
  Inline,
  InlineItem,
  Secondary,
} from '@kinesis/bungle';
import { Disclosure } from '@/types';
import { GHGProtocolIcon } from '@/components/ghg-protocol-icon';
import { disclosurePath } from '@/links';
import { formatDistanceStrings } from '@/date';

// Pure presentational item for `DisclosuresList`. Mirrors suit's
// `disclosure-list-item` and square's `scenarios-list/item` — Card with
// a link-button leading to the detail page, name + last-updated secondary.
// No CardMenu / delete this phase (deferred to Phase 5 polish per the
// 2D.2.b backlog).
const Item = (props: ItemProps) => {
  const { disclosure, inventoryId, now } = props;
  return (
    <Content borderRadiusSize='small'>
      <Card>
        <CardButton as={Link} to={disclosurePath(inventoryId, disclosure.id)}>
          <Content padding='medium' paddingMode='equal'>
            <Inline space='medium'>
              <InlineItem>
                <GHGProtocolIcon />
              </InlineItem>
              <InlineItem ellipsify>
                <Heading as='h3' size='medium'>
                  {disclosure.name}
                </Heading>
                <Secondary>
                  {`Last updated ${formatDistanceStrings(now, disclosure.updatedAt)}`}
                </Secondary>
              </InlineItem>
            </Inline>
          </Content>
        </CardButton>
      </Card>
    </Content>
  );
};

export type ItemProps = {
  disclosure: Disclosure;
  inventoryId: number;
  now: string;
};

export { Item };
